import { supportedLocales, type SupportedLocale } from '@travel-crm/types';
import { defineStore } from 'pinia';
import { ref } from 'vue';

function initialLocale(): SupportedLocale {
  const saved = globalThis.localStorage?.getItem('travel-crm-locale');
  return supportedLocales.includes(saved as SupportedLocale) ? (saved as SupportedLocale) : 'en';
}

export const usePreferencesStore = defineStore('preferences', () => {
  const locale = ref<SupportedLocale>(initialLocale());

  function setLocale(value: SupportedLocale): void {
    locale.value = value;
    globalThis.localStorage?.setItem('travel-crm-locale', value);
  }

  return { locale, setLocale };
});
